export const constant = {
	selector: {
		heightTarget: 'data-m-size-height',
	},
}
